import { useEffect, useState } from 'react';

export interface PaidQuestionTerminationViewModel {
  isServiceTerminated: boolean;
  terminationDate: string;
  isBottomSheetOpen: boolean;
  shouldShowBottomSheet: boolean;
  handleBottomSheet: (open: boolean) => void;
}

const BOTTOM_SHEET_SHOWN_KEY = 'paid_question_termination_shown';

const getTodayString = (): string => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const hasShownBottomSheetToday = (): boolean => {
  try {
    const shownDate = localStorage.getItem(BOTTOM_SHEET_SHOWN_KEY);
    return !!shownDate;
  } catch {
    return false;
  }
};

const markBottomSheetShownToday = (): void => {
  try {
    localStorage.setItem(BOTTOM_SHEET_SHOWN_KEY, getTodayString());
  } catch {
    return;
  }
};

/**
 * 유료질문 서비스 종료 관련 비즈니스 로직을 처리하는 훅
 * 한번만 노출
 * @returns 유료질문 서비스 종료 뷰모델 (상태, 핸들러, 포맷 함수)
 */
const usePaidQuestionTerminationViewModel = (enabled: boolean): PaidQuestionTerminationViewModel => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [shouldShowBottomSheet, setShouldShowBottomSheet] = useState(false);

  const terminationDisplayedDate = '8월 28일';
  const terminationDate = '2025-09-01';

  const isServiceTerminated = (() => {
    const today = new Date();
    const [month, day] = terminationDate.split('/').map(Number);
    const terminationDateObj = new Date(today.getFullYear(), month - 1, day);
    return today >= terminationDateObj;
  })();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!isServiceTerminated && !hasShownBottomSheetToday()) {
      setShouldShowBottomSheet(true);
      setIsBottomSheetOpen(true);
    }
  }, [isServiceTerminated, enabled]);

  const handleBottomSheet = (open: boolean) => {
    setIsBottomSheetOpen(open);
    if (!open) {
      markBottomSheetShownToday();
    }
  };

  return {
    isServiceTerminated,
    terminationDate: terminationDisplayedDate,
    isBottomSheetOpen,
    shouldShowBottomSheet,
    handleBottomSheet,
  };
};

export default usePaidQuestionTerminationViewModel;
